import { render, staticRenderFns } from "./contactus.html?vue&type=template&id=4b5ecfd6&scoped=true&"
import script from "./contactus.vue?vue&type=script&lang=js&"
export * from "./contactus.vue?vue&type=script&lang=js&"
import style0 from "./contactus.scss?vue&type=style&index=0&id=4b5ecfd6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5ecfd6",
  null
  
)

export default component.exports